var React = require('react');

function Robot (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 4.5C10.04 4.5 12.5 6.5 12.5 9.5V13.5H1.5V9.5C1.5 6.5 3.96 4.5 7 4.5ZM7 4.5V0.5M1.5 10.5H12.5M5 10.5V13.5M9 10.5V13.5","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5 8.5C5.27614 8.5 5.5 8.27614 5.5 8C5.5 7.72386 5.27614 7.5 5 7.5C4.72386 7.5 4.5 7.72386 4.5 8C4.5 8.27614 4.72386 8.5 5 8.5Z","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M9 8.5C9.27614 8.5 9.5 8.27614 9.5 8C9.5 7.72386 9.27614 7.5 9 7.5C8.72386 7.5 8.5 7.72386 8.5 8C8.5 8.27614 8.72386 8.5 9 8.5Z","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Robot.defaultProps = {"viewBox":"0 0 14 14","fill":"none"};

module.exports = Robot;

Robot.default = Robot;
